module.exports = __webpack_public_path__ + "img/ic-check.bbc60817.svg";